import React, { createContext, useState } from "react";
import HelpdeskService from "services/HelpdeskService/Helpdesk.service";
import InfoModal from "shared/components/InfoModal";
import { HelpDeskInputFieldEnum } from "./helpDeskInputFieldEnum";

type HelpDeskTooltipContextType = {
  openTooltipModal: (fieldName: HelpDeskInputFieldEnum) => void,
}

export const HelpDeskTooltipContext = createContext<HelpDeskTooltipContextType>({
  openTooltipModal: () => { },
});

export const HelpDeskTooltipProvider: React.FC = ({ children }) => {

  const { fetchedHelpDeskData, fetchData: fetchTooltipData, clearHelpDeskData, loading } = HelpdeskService();

  const [showTooltip, setShowTooltip] = useState<boolean>(false)

  const closeTooltipModal = () => {
    setShowTooltip(false)
    clearHelpDeskData()
  }

  const openTooltipModal = (fieldName: string) => {
    localStorage.removeItem("helpdesk")
    fetchTooltipData({ 'input-field': fieldName });
    setShowTooltip(true)
  }

  return (
    <HelpDeskTooltipContext.Provider
      value={{
        openTooltipModal,
      }}>
      {children}
      <InfoModal
        showModalState={showTooltip}
        handleModalCancel={closeTooltipModal}
        data={fetchedHelpDeskData}
        loading={loading}
      />
    </HelpDeskTooltipContext.Provider>
  );
};
